import React, { useEffect, useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
export function ShopifyDesignDevelopment() {
  const [activeSection, setActiveSection] = useState('go-to-market');
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Update scrolled state for header
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
      // Only update active section visually without affecting URL or scroll position
      const sections = document.querySelectorAll('.service-section[id]');
      sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top;
        const sectionId = section.getAttribute('id');
        if (sectionTop < 200 && sectionTop >= -section.getBoundingClientRect().height + 200) {
          setActiveSection(sectionId);
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    // Handle initial section display only - no automatic scrolling
    const handleInitialLoad = () => {
      // Set default active section without scrolling
      setActiveSection('go-to-market');
    };
    handleInitialLoad();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);
  const scrollToSection = sectionId => {
    setActiveSection(sectionId);
    // Don't update URL with hash to avoid bounce-back issues
    const element = document.getElementById(sectionId);
    if (element) {
      // Use smooth scrolling for user-initiated navigation
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="min-h-screen bg-[#FAF7F2]" data-id="element-573">
      <Header data-id="element-574" />
      {/* Hero Section - Updated with proper top padding for fixed header */}
      <section className="pt-28 pb-20 px-6 md:px-10" data-id="element-575">
        <div className="max-w-[1400px] mx-auto" data-id="element-576">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden" data-id="element-577">
            <div className="grid md:grid-cols-2" data-id="element-578">
              <div className="p-6 md:p-12 lg:p-16 flex flex-col justify-center" data-id="element-579">
                <h1 className="text-[#2C2416] text-[clamp(48px,6vw,64px)] font-light leading-[1.1] tracking-[-3px] mb-6 font-['Inter']" data-id="element-580">
                  Shopify Design &{' '}
                  <span className="text-[#D4A574]" data-id="element-581">Development</span>
                </h1>
                <p className="text-[#8B7355] text-xl max-w-lg mb-10 leading-relaxed font-['Inter']" data-id="element-582">
                  Shopify Partners with 15 years of eCommerce experience. We
                  design, build, and launch Shopify stores - faster, with more
                  iterations, and ready to sell from day one.
                </p>
                <div className="flex flex-wrap gap-5" data-id="element-583">
                  <a href="/contact" className="bg-[#2C2416] text-[#FAF7F2] px-9 py-[18px] rounded-full font-medium tracking-[0.5px] hover:scale-105 transition-all duration-300 hover:bg-[#D4A574] font-['Inter']" data-id="element-584">
                    Start Your Project
                  </a>
                </div>
              </div>
              <div className="bg-white flex items-center justify-center min-h-[400px] md:min-h-[600px] overflow-hidden relative" data-id="element-585">
                <svg className="w-full h-full absolute inset-0" viewBox="0 0 800 1000" preserveAspectRatio="xMidYMid slice" data-id="element-586">
                  <defs data-id="element-587">
                    <linearGradient id="shopifyGrad" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-588">
                      <stop offset="0%" style={{
                      stopColor: '#FFFFFF',
                      stopOpacity: 1
                    }} data-id="element-589" />
                      <stop offset="100%" style={{
                      stopColor: '#FAF7F2',
                      stopOpacity: 1
                    }} data-id="element-590" />
                    </linearGradient>
                  </defs>

                  {/* Background */}
                  <rect width="100%" height="100%" fill="url(#shopifyGrad)" data-id="element-591" />

                  {/* Strategic Growth - Ascending Elements */}
                  <g transform="translate(400, 700)" data-id="element-592">
                    {/* Base Foundation */}
                    <rect x="-300" y="0" width="600" height="8" fill="#2C2416" opacity="0.1" data-id="element-593" />

                    {/* Growth Bars - Ascending */}
                    <rect x="-250" y="-80" width="80" height="80" fill="#D4A574" opacity="0.15" data-id="element-594" />
                    <rect x="-250" y="-80" width="80" height="80" fill="none" stroke="#2C2416" strokeWidth="2" data-id="element-595" />

                    <rect x="-120" y="-160" width="80" height="160" fill="#D4A574" opacity="0.15" data-id="element-596" />
                    <rect x="-120" y="-160" width="80" height="160" fill="none" stroke="#2C2416" strokeWidth="2" data-id="element-597" />

                    <rect x="10" y="-240" width="80" height="240" fill="#D4A574" opacity="0.2" data-id="element-598" />
                    <rect x="10" y="-240" width="80" height="240" fill="none" stroke="#2C2416" strokeWidth="2" data-id="element-599" />

                    <rect x="140" y="-320" width="80" height="320" fill="#D4A574" opacity="0.25" data-id="element-600" />
                    <rect x="140" y="-320" width="80" height="320" fill="none" stroke="#2C2416" strokeWidth="2" data-id="element-601" />

                    {/* Connecting Growth Line */}
                    <path d="M -210 -40 L -80 -80 L 50 -120 L 180 -160" stroke="#D4A574" strokeWidth="3" fill="none" opacity="0.6" data-id="element-602" />

                    {/* Data Points */}
                    <circle cx="-210" cy="-40" r="6" fill="#D4A574" data-id="element-603" />
                    <circle cx="-80" cy="-80" r="6" fill="#D4A574" data-id="element-604" />
                    <circle cx="50" cy="-120" r="6" fill="#D4A574" data-id="element-605" />
                    <circle cx="180" cy="-160" r="6" fill="#D4A574" data-id="element-606" />

                    {/* Subtle Grid Background */}
                    <line x1="-300" y1="-100" x2="300" y2="-100" stroke="#2C2416" strokeWidth="0.5" opacity="0.1" data-id="element-607" />
                    <line x1="-300" y1="-200" x2="300" y2="-200" stroke="#2C2416" strokeWidth="0.5" opacity="0.1" data-id="element-608" />
                    <line x1="-300" y1="-300" x2="300" y2="-300" stroke="#2C2416" strokeWidth="0.5" opacity="0.1" data-id="element-609" />
                  </g>

                  {/* Floating Strategic Elements */}
                  <g transform="translate(400, 300)" data-id="element-610">
                    <circle cx="-200" cy="-100" r="40" fill="none" stroke="#D4A574" strokeWidth="1" opacity="0.2" data-id="element-611" />
                    <circle cx="220" cy="-50" r="30" fill="none" stroke="#2C2416" strokeWidth="1" opacity="0.15" data-id="element-612" />
                  </g>
                </svg>

                {/* Overlay Content */}
                <div className="relative z-10 text-center" data-id="element-613">
                  <div className="w-24 h-24 rounded-full bg-[#2C2416] flex items-center justify-center mx-auto mb-6 shadow-2xl" data-id="element-614">
                    <span className="text-[#D4A574] text-4xl" data-id="element-615">📈</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Go-to-Market Strategy */}
      <section id="go-to-market" className="service-section py-24 bg-[#FAF7F2] scroll-mt-36 px-6 md:px-10" data-id="element-616">
        <div className="max-w-[1400px] mx-auto" data-id="element-617">
          <div className="grid md:grid-cols-2 gap-20 items-center" data-id="element-618">
            <div data-id="element-619">
              <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-6 font-['Inter']" data-id="element-620">
                Theme Setup
              </h2>
              <p className="text-[#8B7355] text-lg mb-8 leading-relaxed font-['Inter']" data-id="element-621">
                We use our own custom theme with extensive customisable blocks -
                not a template, but a flexible foundation built for speed. More
                options, faster builds, easier updates down the track.
              </p>
              <ul className="mb-10 space-y-4" data-id="element-622">
                {['Custom theme with modular blocks', 'Faster builds without sacrificing flexibility', 'Easy for you to update post-launch', 'Built for performance and conversion', 'Mobile-first responsive design', 'No bloated code or unnecessary apps'].map((item, index) => <li key={index} className="flex items-start text-[#8B7355] font-['Inter'] pl-8 relative" data-id="element-623">
                    <span className="text-[#D4A574] absolute left-0 font-semibold" data-id="element-624">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg" data-id="element-625">
              <div className="aspect-[4/3] relative overflow-hidden bg-[#FAF7F2]" data-id="element-626">
                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" data-id="element-627">
                  {/* Theme Setup: Modular Building Blocks */}
                  <defs data-id="element-628">
                    <pattern id="themeGrid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-629">
                      <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#2C2416" strokeWidth="0.5" opacity="0.1" data-id="element-630" />
                    </pattern>
                  </defs>

                  <rect width="100%" height="100%" fill="#FAF7F2" data-id="element-631" />
                  <rect width="100%" height="100%" fill="url(#themeGrid)" data-id="element-632" />

                  {/* Modular Blocks */}
                  <g transform="translate(200, 150)" data-id="element-633">
                    {/* Central Module */}
                    <rect x="-40" y="-40" width="80" height="80" fill="#D4A574" opacity="0.2" data-id="element-634" />
                    <rect x="-40" y="-40" width="80" height="80" fill="none" stroke="#2C2416" strokeWidth="2" data-id="element-635" />

                    {/* Surrounding Modules */}
                    <rect x="-120" y="-40" width="60" height="60" fill="none" stroke="#D4A574" strokeWidth="1.5" opacity="0.6" data-id="element-636" />
                    <rect x="60" y="-40" width="60" height="60" fill="none" stroke="#D4A574" strokeWidth="1.5" opacity="0.6" data-id="element-637" />
                    <rect x="-40" y="-120" width="60" height="60" fill="none" stroke="#D4A574" strokeWidth="1.5" opacity="0.6" data-id="element-638" />
                    <rect x="-40" y="60" width="60" height="60" fill="none" stroke="#D4A574" strokeWidth="1.5" opacity="0.6" data-id="element-639" />

                    {/* Connection Lines */}
                    <line x1="-60" y1="0" x2="-40" y2="0" stroke="#2C2416" strokeWidth="1" opacity="0.3" data-id="element-640" />
                    <line x1="40" y1="0" x2="60" y2="0" stroke="#2C2416" strokeWidth="1" opacity="0.3" data-id="element-641" />
                    <line x1="0" y1="-60" x2="0" y2="-40" stroke="#2C2416" strokeWidth="1" opacity="0.3" data-id="element-642" />
                    <line x1="0" y1="40" x2="0" y2="60" stroke="#2C2416" strokeWidth="1" opacity="0.3" data-id="element-643" />

                    {/* Corner Accents */}
                    <circle cx="-90" cy="-10" r="3" fill="#D4A574" data-id="element-644" />
                    <circle cx="90" cy="-10" r="3" fill="#D4A574" data-id="element-645" />
                    <circle cx="-10" cy="-90" r="3" fill="#D4A574" data-id="element-646" />
                    <circle cx="-10" cy="90" r="3" fill="#D4A574" data-id="element-647" />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Marketing Automation */}
      <section id="marketing-automation" className="service-section py-24 bg-white scroll-mt-36 px-6 md:px-10" data-id="element-648">
        <div className="max-w-[1400px] mx-auto" data-id="element-649">
          <div className="grid md:grid-cols-2 gap-20 items-center" data-id="element-650">
            <div className="md:order-2" data-id="element-651">
              <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-6 font-['Inter']" data-id="element-652">
                Design & Iterations
              </h2>
              <p className="text-[#8B7355] text-lg mb-8 leading-relaxed font-['Inter']" data-id="element-653">
                Modern tools, faster iterations. We deliver design variations
                quickly so you can see options and move forward without endless
                rounds of feedback. More concepts, quicker decisions, lower
                costs.
              </p>
              <ul className="mb-10 space-y-4" data-id="element-654">
                {['Rapid design iterations', 'Multiple variations to choose from', 'Custom design for your brand', 'No endless back-and-forth', 'Modern design tools', 'Lower design costs'].map((item, index) => <li key={index} className="flex items-start text-[#8B7355] font-['Inter'] pl-8 relative" data-id="element-655">
                    <span className="text-[#D4A574] absolute left-0 font-semibold" data-id="element-656">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg md:order-1" data-id="element-657">
              <div className="aspect-[4/3] relative overflow-hidden bg-white" data-id="element-658">
                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" data-id="element-659">
                  {/* Design & Iterations: Multiple Variations */}
                  <rect width="100%" height="100%" fill="#FFFFFF" data-id="element-660" />

                  <g transform="translate(200, 150)" data-id="element-661">
                    {/* Overlapping Design Frames */}
                    <rect x="-100" y="-80" width="160" height="120" fill="#FAF7F2" stroke="#2C2416" strokeWidth="2" opacity="0.9" data-id="element-662" />
                    <rect x="-80" y="-60" width="160" height="120" fill="#FAF7F2" stroke="#D4A574" strokeWidth="2" opacity="0.7" data-id="element-663" />
                    <rect x="-60" y="-40" width="160" height="120" fill="#FFFFFF" stroke="#2C2416" strokeWidth="2" data-id="element-664" />

                    {/* Iteration Markers */}
                    <circle cx="-90" cy="-70" r="4" fill="#D4A574" data-id="element-665" />
                    <circle cx="-70" cy="-50" r="4" fill="#D4A574" data-id="element-666" />
                    <circle cx="-50" cy="-30" r="4" fill="#D4A574" data-id="element-667" />

                    {/* Design Elements Inside Frames */}
                    <line x1="-40" y1="-20" x2="40" y2="-20" stroke="#2C2416" strokeWidth="2" opacity="0.3" data-id="element-668" />
                    <line x1="-40" y1="0" x2="60" y2="0" stroke="#2C2416" strokeWidth="2" opacity="0.3" data-id="element-669" />
                    <line x1="-40" y1="20" x2="30" y2="20" stroke="#2C2416" strokeWidth="2" opacity="0.3" data-id="element-670" />

                    <rect x="-40" y="40" width="30" height="20" fill="#D4A574" opacity="0.3" data-id="element-671" />
                  </g>

                  {/* Floating Variation Indicators */}
                  <text x="50" y="40" fontSize="10" fill="#8B7355" opacity="0.5" data-id="element-672">
                    v1
                  </text>
                  <text x="70" y="60" fontSize="10" fill="#8B7355" opacity="0.5" data-id="element-673">
                    v2
                  </text>
                  <text x="90" y="80" fontSize="10" fill="#8B7355" opacity="0.5" data-id="element-674">
                    v3
                  </text>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* App Selection & Setup */}
      <section id="app-selection" className="service-section py-24 bg-[#FAF7F2] scroll-mt-36 px-6 md:px-10" data-id="element-675">
        <div className="max-w-[1400px] mx-auto" data-id="element-676">
          <div className="grid md:grid-cols-2 gap-20 items-center" data-id="element-677">
            <div data-id="element-678">
              <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-6 font-['Inter']" data-id="element-679">
                App Selection & Setup
              </h2>
              <p className="text-[#8B7355] text-lg mb-8 leading-relaxed font-['Inter']" data-id="element-680">
                We help you choose the right apps and set them up properly -
                subscriptions, loyalty, reviews, email, whatever your store
                needs. No bloated app stacks, just what works.
              </p>
              <ul className="mb-10 space-y-4" data-id="element-681">
                {['App strategy and selection', 'Subscription app setup', 'Loyalty program configuration', 'Reviews and UGC integration', 'Klaviyo email setup', 'Configured and tested before launch'].map((item, index) => <li key={index} className="flex items-start text-[#8B7355] font-['Inter'] pl-8 relative" data-id="element-682">
                    <span className="text-[#D4A574] absolute left-0 font-semibold" data-id="element-683">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg" data-id="element-684">
              <div className="aspect-[4/3] relative overflow-hidden bg-[#FAF7F2]" data-id="element-685">
                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" data-id="element-686">
                  {/* App Selection: Connected Ecosystem */}
                  <rect width="100%" height="100%" fill="#FAF7F2" data-id="element-687" />

                  <g transform="translate(200, 150)" data-id="element-688">
                    {/* Central Hub */}
                    <circle cx="0" cy="0" r="30" fill="#2C2416" opacity="0.1" data-id="element-689" />
                    <circle cx="0" cy="0" r="30" fill="none" stroke="#2C2416" strokeWidth="2" data-id="element-690" />

                    {/* App Nodes */}
                    <circle cx="-80" cy="-60" r="18" fill="#D4A574" opacity="0.15" data-id="element-691" />
                    <circle cx="-80" cy="-60" r="18" fill="none" stroke="#D4A574" strokeWidth="1.5" data-id="element-692" />

                    <circle cx="80" cy="-60" r="18" fill="#D4A574" opacity="0.15" data-id="element-693" />
                    <circle cx="80" cy="-60" r="18" fill="none" stroke="#D4A574" strokeWidth="1.5" data-id="element-694" />

                    <circle cx="-80" cy="60" r="18" fill="#D4A574" opacity="0.15" data-id="element-695" />
                    <circle cx="-80" cy="60" r="18" fill="none" stroke="#D4A574" strokeWidth="1.5" data-id="element-696" />

                    <circle cx="80" cy="60" r="18" fill="#D4A574" opacity="0.15" data-id="element-697" />
                    <circle cx="80" cy="60" r="18" fill="none" stroke="#D4A574" strokeWidth="1.5" data-id="element-698" />

                    <circle cx="0" cy="-90" r="18" fill="#D4A574" opacity="0.15" data-id="element-699" />
                    <circle cx="0" cy="-90" r="18" fill="none" stroke="#D4A574" strokeWidth="1.5" data-id="element-700" />

                    <circle cx="0" cy="90" r="18" fill="#D4A574" opacity="0.15" data-id="element-701" />
                    <circle cx="0" cy="90" r="18" fill="none" stroke="#D4A574" strokeWidth="1.5" data-id="element-702" />

                    {/* Connection Lines */}
                    <line x1="0" y1="0" x2="-80" y2="-60" stroke="#2C2416" strokeWidth="1" opacity="0.2" data-id="element-703" />
                    <line x1="0" y1="0" x2="80" y2="-60" stroke="#2C2416" strokeWidth="1" opacity="0.2" data-id="element-704" />
                    <line x1="0" y1="0" x2="-80" y2="60" stroke="#2C2416" strokeWidth="1" opacity="0.2" data-id="element-705" />
                    <line x1="0" y1="0" x2="80" y2="60" stroke="#2C2416" strokeWidth="1" opacity="0.2" data-id="element-706" />
                    <line x1="0" y1="0" x2="0" y2="-90" stroke="#2C2416" strokeWidth="1" opacity="0.2" data-id="element-707" />
                    <line x1="0" y1="0" x2="0" y2="90" stroke="#2C2416" strokeWidth="1" opacity="0.2" data-id="element-708" />

                    {/* Data Flow Indicators */}
                    <circle cx="-40" cy="-30" r="2" fill="#D4A574" opacity="0.6" data-id="element-709" />
                    <circle cx="40" cy="-30" r="2" fill="#D4A574" opacity="0.6" data-id="element-710" />
                    <circle cx="-40" cy="30" r="2" fill="#D4A574" opacity="0.6" data-id="element-711" />
                    <circle cx="40" cy="30" r="2" fill="#D4A574" opacity="0.6" data-id="element-712" />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Subscription Commerce Setup */}
      <section id="subscription-commerce" className="service-section py-24 bg-white scroll-mt-36 px-6 md:px-10" data-id="element-713">
        <div className="max-w-[1400px] mx-auto" data-id="element-714">
          <div className="grid md:grid-cols-2 gap-20 items-center" data-id="element-715">
            <div className="md:order-2" data-id="element-716">
              <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-6 font-['Inter']" data-id="element-717">
                Migrations
              </h2>
              <p className="text-[#8B7355] text-lg mb-8 leading-relaxed font-['Inter']" data-id="element-718">
                Moving to Shopify from WooCommerce, Magento, or another
                platform? We handle data migration using trusted partner apps -
                customers, orders, products, all moved properly with nothing
                left behind.
              </p>
              <ul className="mb-10 space-y-4" data-id="element-719">
                {['WooCommerce, Magento & legacy platforms', 'Trusted data migration partners', 'Complete customer and order history', 'Product data and images', 'SEO-safe URL redirects', 'Zero downtime process'].map((item, index) => <li key={index} className="flex items-start text-[#8B7355] font-['Inter'] pl-8 relative" data-id="element-720">
                    <span className="text-[#D4A574] absolute left-0 font-semibold" data-id="element-721">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg md:order-1" data-id="element-722">
              <div className="aspect-[4/3] relative overflow-hidden bg-white" data-id="element-723">
                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" data-id="element-724">
                  {/* Migrations: Platform Transfer Flow */}
                  <defs data-id="element-725">
                    <linearGradient id="migrationFlow" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-726">
                      <stop offset="0%" style={{
                      stopColor: '#2C2416',
                      stopOpacity: 0.2
                    }} data-id="element-727" />
                      <stop offset="50%" style={{
                      stopColor: '#D4A574',
                      stopOpacity: 0.6
                    }} data-id="element-728" />
                      <stop offset="100%" style={{
                      stopColor: '#2C2416',
                      stopOpacity: 0.2
                    }} data-id="element-729" />
                    </linearGradient>
                  </defs>

                  <rect width="100%" height="100%" fill="#FFFFFF" data-id="element-730" />

                  {/* Source Platform */}
                  <g transform="translate(80, 150)" data-id="element-731">
                    <rect x="-40" y="-50" width="80" height="100" fill="#FAF7F2" stroke="#2C2416" strokeWidth="2" data-id="element-732" />
                    <text x="0" y="0" fontSize="12" fill="#8B7355" textAnchor="middle" opacity="0.5" data-id="element-733">
                      Old
                    </text>
                  </g>

                  {/* Migration Flow */}
                  <path d="M 120 150 Q 200 150 280 150" stroke="url(#migrationFlow)" strokeWidth="3" fill="none" data-id="element-734" />
                  <path d="M 120 140 Q 200 140 280 140" stroke="#2C2416" strokeWidth="1" fill="none" opacity="0.2" data-id="element-735" />
                  <path d="M 120 160 Q 200 160 280 160" stroke="#2C2416" strokeWidth="1" fill="none" opacity="0.2" data-id="element-736" />

                  {/* Data Points Moving */}
                  <circle cx="160" cy="150" r="4" fill="#D4A574" opacity="0.8" data-id="element-737" />
                  <circle cx="200" cy="145" r="3" fill="#D4A574" opacity="0.6" data-id="element-738" />
                  <circle cx="240" cy="155" r="3" fill="#D4A574" opacity="0.6" data-id="element-739" />

                  {/* Arrow */}
                  <polygon points="280,145 290,150 280,155" fill="#D4A574" opacity="0.6" data-id="element-740" />

                  {/* Destination Platform */}
                  <g transform="translate(320, 150)" data-id="element-741">
                    <rect x="-40" y="-50" width="80" height="100" fill="#D4A574" fillOpacity="0.1" stroke="#D4A574" strokeWidth="2" data-id="element-742" />
                    <text x="0" y="0" fontSize="12" fill="#2C2416" textAnchor="middle" opacity="0.7" data-id="element-743">
                      New
                    </text>
                  </g>

                  {/* Success Indicators */}
                  <circle cx="320" cy="100" r="3" fill="#D4A574" data-id="element-744" />
                  <circle cx="320" cy="200" r="3" fill="#D4A574" data-id="element-745" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Email & SMS Flows */}
      <section id="email-sms" className="service-section py-24 bg-[#FAF7F2] scroll-mt-36 px-6 md:px-10" data-id="element-746">
        <div className="max-w-[1400px] mx-auto" data-id="element-747">
          <div className="grid md:grid-cols-2 gap-20 items-center" data-id="element-748">
            <div data-id="element-749">
              <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-6 font-['Inter']" data-id="element-750">
                Launch & Onboarding
              </h2>
              <p className="text-[#8B7355] text-lg mb-8 leading-relaxed font-['Inter']" data-id="element-751">
                We don't just hand over a store and disappear. We launch
                properly - customer communication campaigns, video guides for
                new portals and features, and support to make sure everything
                runs smoothly.
              </p>
              <ul className="mb-10 space-y-4" data-id="element-752">
                {['Seamless launch process', 'Customer communication campaigns', 'Video guides for customer portals', 'Subscription and loyalty app walkthroughs', 'Team training if needed', 'Post-launch support included'].map((item, index) => <li key={index} className="flex items-start text-[#8B7355] font-['Inter'] pl-8 relative" data-id="element-753">
                    <span className="text-[#D4A574] absolute left-0 font-semibold" data-id="element-754">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
              <a href="/contact" className="inline-block bg-transparent border-2 border-[#2C2416] text-[#2C2416] px-9 py-4 rounded-full font-medium tracking-[0.5px] hover:scale-105 transition-all duration-300 hover:bg-[#2C2416] hover:text-[#FAF7F2] font-['Inter']" data-id="element-755">
                Get in Touch
              </a>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg" data-id="element-756">
              <div className="aspect-[4/3] relative overflow-hidden bg-[#FAF7F2]" data-id="element-757">
                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" data-id="element-758">
                  {/* Launch & Onboarding: Rocket Launch Sequence */}
                  <rect width="100%" height="100%" fill="#FAF7F2" data-id="element-759" />

                  <g transform="translate(200, 200)" data-id="element-760">
                    {/* Launch Platform */}
                    <rect x="-60" y="0" width="120" height="8" fill="#2C2416" opacity="0.2" data-id="element-761" />

                    {/* Rocket Body */}
                    <path d="M -20 0 L -20 -80 L 0 -100 L 20 -80 L 20 0 Z" fill="#2C2416" opacity="0.1" data-id="element-762" />
                    <path d="M -20 0 L -20 -80 L 0 -100 L 20 -80 L 20 0 Z" fill="none" stroke="#2C2416" strokeWidth="2" data-id="element-763" />

                    {/* Window */}
                    <circle cx="0" cy="-50" r="8" fill="#D4A574" opacity="0.3" data-id="element-764" />
                    <circle cx="0" cy="-50" r="8" fill="none" stroke="#D4A574" strokeWidth="1.5" data-id="element-765" />

                    {/* Fins */}
                    <path d="M -20 -20 L -35 0 L -20 0 Z" fill="#D4A574" opacity="0.2" data-id="element-766" />
                    <path d="M 20 -20 L 35 0 L 20 0 Z" fill="#D4A574" opacity="0.2" data-id="element-767" />

                    {/* Launch Trail */}
                    <circle cx="0" cy="15" r="12" fill="#D4A574" opacity="0.15" data-id="element-768" />
                    <circle cx="0" cy="30" r="18" fill="#D4A574" opacity="0.1" data-id="element-769" />
                    <circle cx="0" cy="45" r="24" fill="#D4A574" opacity="0.05" data-id="element-770" />

                    {/* Support Stars */}
                    <circle cx="-80" cy="-60" r="2" fill="#D4A574" opacity="0.6" data-id="element-771" />
                    <circle cx="80" cy="-40" r="2" fill="#D4A574" opacity="0.6" data-id="element-772" />
                    <circle cx="-60" cy="-100" r="2" fill="#D4A574" opacity="0.6" data-id="element-773" />
                    <circle cx="70" cy="-80" r="2" fill="#D4A574" opacity="0.6" data-id="element-774" />

                    {/* Trajectory Path */}
                    <path d="M 0 -100 Q -30 -130 -40 -160" stroke="#D4A574" strokeWidth="1" strokeDasharray="2,3" fill="none" opacity="0.3" data-id="element-775" />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Features Grid */}
      <section className="py-24 bg-white px-6 md:px-10" data-id="element-776">
        <div className="max-w-[1400px] mx-auto" data-id="element-777">
          <div className="text-center mb-20" data-id="element-778">
            <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-5 font-['Inter']" data-id="element-779">
              Why Work With Us
            </h2>
            <p className="text-[#8B7355] text-lg font-['Inter']" data-id="element-780">
              Shopify Partners backed by 15 years of ecommerce experience
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-781">
            {[{
            title: 'Official Shopify Partners',
            description: "We're in the Shopify Partner Program. That means direct support, early access to features, and a team that knows the platform inside out."
          }, {
            title: '15 Years Experience',
            description: "Hundreds of stores built. We've seen what works and what doesn't - and we bring that experience to every Shopify project."
          }, {
            title: 'Faster Design Process',
            description: 'Modern tools mean more variations, quicker decisions, and lower costs. No endless back-and-forth.'
          }, {
            title: 'Our Own Theme',
            description: 'A custom theme with modular blocks built for speed and flexibility. Faster builds, easier updates.'
          }, {
            title: 'Trusted Migration Partners',
            description: 'We use proven data migration apps. Customers, orders, products - moved properly with nothing left behind.'
          }, {
            title: 'We Stick Around',
            description: "Launch support, video guides, customer comms, and ongoing help. We're here after go-live."
          }].map((feature, index) => <motion.div key={index} className="bg-[#FAF7F2] p-8 rounded-xl border border-[#D4A57420] transition-all duration-300 hover:shadow-xl hover:-translate-y-1" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} data-id="element-782">
                <h4 className="text-[#2C2416] text-xl font-medium mb-4 font-['Inter']" data-id="element-783">
                  {feature.title}
                </h4>
                <p className="text-[#8B7355] font-['Inter'] text-[15px] leading-relaxed" data-id="element-784">
                  {feature.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-20 px-6 md:px-10" data-id="element-785">
        <div className="max-w-[1400px] mx-auto" data-id="element-786">
          <div className="bg-[#2C2416] text-center p-8 md:p-16 lg:p-24 rounded-3xl" data-id="element-787">
            <h2 className="text-[#FAF7F2] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-4 md:mb-6 font-['Inter']" data-id="element-788">
              Let's Build Your Shopify Store
            </h2>
            <p className="text-[#D4A574] text-lg md:text-xl max-w-2xl mx-auto mb-8 md:mb-12 font-['Inter'] leading-relaxed" data-id="element-789">
              New build, migration, or platform switch. 15 years experience,
              official Shopify Partners.
            </p>
            <div className="flex flex-wrap justify-center gap-5" data-id="element-790">
              <a href="/contact" className="bg-[#D4A574] text-[#2C2416] px-9 py-[18px] rounded-full font-medium tracking-[0.5px] hover:scale-105 transition-all duration-300 hover:bg-[#FAF7F2] font-['Inter']" data-id="element-791">
                Start Your Project
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-792" />
    </div>;
}